import moment from "moment";
import { useEffect, useState } from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";

interface SentenciaData {
    linea: number;
    agnoCabecera: number;
    mesCabecera: number;
    urlCabecera: string;
    urlCuerpo: string;
    idExpediente: number;
    noExpediente: string;
    noSentencia: string;
    noUnico: string;
    noInterno: string;
    idTribunal: string;
    descTribunal: string;
    idMateria: string;
    descMateria: string;
    fechaFallo: string;
    involucrados: string;
    guidBlob: string;
    tipoDocumentoAdjunto: string;
    totalFilas: number;
    urlBlob: string;
    extension: string;
    origen: number;
    activo: boolean;
}

interface SentenciasResponse {
    draw: string;
    recordsFiltered: number;
    recordsTotal: number;
    data: SentenciaData[];
}

const RecordSentencias = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<SentenciaData[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            setIsLoading(true);
            const response = await API.getActionExternal(
                `https://background-check-background-check.up.railway.app/functionaries/judicial-cases/?identifier=${id}&start=0&length=10`
            );

            if (response.status) {
                console.log("Fetched sentencias records successfully.", response);
                const data: any = response.data;
                setRecords(data.data || []);
            } else {
                console.error("Error fetching sentencias records:", response.statusText);
                setRecords([]);
            }
        } catch (error) {
            console.error("Error fetching sentencias records:", error);
            setRecords([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }, [id]);

    if (isLoading) {
        return (
            <Card className="my-4">
                <Card.Body className="text-center py-4">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    if (records.length === 0) {
        return null;
    }

    return (
        <Card className="my-4">
            <Card.Header className="display-4">
                {t("Sentencias")}
                <Badge bg="danger" className="ms-3">
                    {records.length}
                </Badge>
            </Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{t("Sentencia")}</th>
                                <th>{t("Tribunal")}</th>
                                <th>{t("Materia")}</th>
                                <th>{t("Fecha")}</th>
                                <th>{t("Involucrados")}</th>
                                <th>{t("Documento")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((item, index) => {
                                console.log("Rendering sentencia item:", item);
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <strong>{item.noSentencia}</strong>
                                            {item.noExpediente && item.noExpediente !== "N/D" && (
                                                <>
                                                    <br />
                                                    <small className="text-muted">
                                                        Exp: {item.noExpediente}
                                                    </small>
                                                </>
                                            )}
                                            {item.noUnico && item.noUnico !== "N/D" && (
                                                <>
                                                    <br />
                                                    <small className="text-muted">
                                                        Único: {item.noUnico}
                                                    </small>
                                                </>
                                            )}
                                        </td>
                                        <td>{item.descTribunal}</td>
                                        <td>
                                            {item.descMateria && item.descMateria !== "N/D"
                                                ? item.descMateria
                                                : "-"}
                                        </td>
                                        <td>
                                            {item.fechaFallo
                                                ? moment(item.fechaFallo).format("DD/MM/YYYY")
                                                : "-"}
                                        </td>
                                        <td>
                                            <div style={{
                                                maxWidth: "300px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}>
                                                {item.involucrados}
                                            </div>
                                        </td>
                                        <td>
                                            {item.urlBlob ? (
                                                <a
                                                    href={item.urlBlob}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="btn btn-sm btn-primary"
                                                >
                                                    <i className="fa fa-file-pdf me-2"></i>
                                                    {t("Ver PDF")}
                                                </a>
                                            ) : (
                                                <span className="text-muted">-</span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
            <Card.Footer className="text-muted">
                <small>
                    <i className="fa fa-info-circle me-2"></i>
                    {t("Total de sentencias encontradas")}: {records.length}
                </small>
            </Card.Footer>
        </Card>
    );
};

export default RecordSentencias;
